<script>
    import { onMount, createEventDispatcher } from "svelte";
    import Conexoes from "../Classes/Conexoes";
    import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
    import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
    import Constantes from "../Classes/Constantes";

    const dispatch = createEventDispatcher();
    const conexao = new Conexoes(Constantes.url_base_nutri);

    export let showModal = false;
    export let params;

    let diaNascimento = "";
    let mesNascimento = "";
    let anoNascimento = "";
    let horarios = [];
    let apagavel = false;
    let horariosSelecionados = [];
    let mensagemConfirmacao = "";
    let mensagemConfirmacao2 = "";
    let mostrandoModal = false;

    let horarioSelecionado = null;
    let mostrarCaixaDialogo = false;
    let mensagemCaixaDialogo = "";
    let isLoading = false;

    const GOOGLE_ADS_APPOINTMENT_CONVERSION = "AW-964653439/sRuBCPTG2P0cEP_i_csD";
    const GOOGLE_ADS_WHATSAPP_CONVERSION = "AW-964653439/NuFwCM3h3-0cEP_i_csD";

    export let ordem = 0;
    export let filtroOnline = 0;

    $: horariosFiltrados = horarios.filter(h => h.online == filtroOnline);

    const diasDaSemana = ["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"];

    let dadosAgendamento = {
        nome: "", ddd: "", telefone: "", email: "",
        data: "", hora: "", id: "", dataNascimento: "", online: 0
    };

    $: horarioSelecionadoId = horarioSelecionado?.id;

    let horariosCarregados = false;

    onMount(() => {
        if (params === "true") { apagavel = true; showModal = true; }
    });

    $: if (showModal && !horariosCarregados) {
        horariosCarregados = true;
        carregarHorarios();
    }

    async function carregarHorarios() {
        isLoading = true;
        const resposta = await conexao.conecta("listar_horarios.php");
        isLoading = false;
        horarios = resposta || [];
    }

    function handleSelecaoHorario(id) {
        horariosSelecionados = horariosSelecionados.includes(id)
            ? horariosSelecionados.filter(h => h !== id)
            : [...horariosSelecionados, id];
    }

    async function confirmarAgendamento() {
        mensagemConfirmacao = "";
        mensagemConfirmacao2 = "";
        if (!dadosAgendamento.nome) { mensagemConfirmacao2 = "Por favor, preencha o nome completo."; mostrarCaixaDialogo = true; return; }
        if (!dadosAgendamento.dataNascimento) { mensagemConfirmacao2 = "Por favor, preencha a data de nascimento."; mostrarCaixaDialogo = true; return; }
        if (!dadosAgendamento.ddd || !/^\d{2}$/.test(dadosAgendamento.ddd)) { mensagemConfirmacao2 = "Por favor, preencha o DDD corretamente (2 dígitos)."; mostrarCaixaDialogo = true; return; }
        if (!dadosAgendamento.telefone || !/^\d{9}$/.test(dadosAgendamento.telefone)) { mensagemConfirmacao2 = "Por favor, preencha o telefone corretamente (9 dígitos)."; mostrarCaixaDialogo = true; return; }

        let tipoTexto = filtroOnline === 1 ? "ONLINE" : "PRESENCIAL";
        mensagemCaixaDialogo = `Confirmar agendamento <b>${tipoTexto}</b> para ${dadosAgendamento.nome} em ${formatarData(dadosAgendamento.data)} (${getDiaDaSemana(dadosAgendamento.data)}) às ${dadosAgendamento.hora}?<br>Telefone: (${dadosAgendamento.ddd}) ${dadosAgendamento.telefone}<br>Data de nascimento: ${formatarData(dadosAgendamento.dataNascimento)}<br>E-mail: ${dadosAgendamento.email || "Não informado"}`;
        mostrarCaixaDialogo = true;
    }

    async function apagarHorarios() {
        if (horariosSelecionados.length === 0) { mensagemCaixaDialogo = "Selecione pelo menos um horário para apagar."; mostrarCaixaDialogo = true; return; }
        mensagemCaixaDialogo = "Tem certeza que deseja apagar os horários selecionados?";
        mostrarCaixaDialogo = true;
    }

    function getDiaDaSemana(dataString) {
        const [ano, mes, dia] = dataString.split("-").map(Number);
        return diasDaSemana[new Date(ano, mes - 1, dia).getDay()];
    }

    function formatarData(dataString) {
        const [ano, mes, dia] = dataString.split("-").map(Number);
        return `${dia.toString().padStart(2,"0")}/${mes.toString().padStart(2,"0")}/${ano}`;
    }

    function agruparPorData(listaHorarios) {
        return listaHorarios.reduce((acc, horario) => {
            const data = horario.inicio.split(" ")[0];
            if (!acc[data]) acc[data] = [];
            acc[data].push(horario);
            return acc;
        }, {});
    }

    async function confirmarAcao() {
        mensagemConfirmacao2 = "";
        mensagemConfirmacao = "";

        if (horariosSelecionados.length > 0 && apagavel) {
            isLoading = true;
            const resposta = await conexao.conecta("apagar_horarios.php", { body: { ids: horariosSelecionados } });
            isLoading = false;
            if (resposta.mensagem) {
                mensagemCaixaDialogo = resposta.mensagem;
                mostrarCaixaDialogo = true;
                await carregarHorarios();
                horariosSelecionados = [];
            } else {
                mensagemCaixaDialogo = "Erro ao apagar horários.";
                mostrarCaixaDialogo = true;
            }
        } else if (horarioSelecionado) {
            isLoading = true;
            const telefoneCompleto = dadosAgendamento.ddd + dadosAgendamento.telefone;
            const resposta = await conexao.conecta("agendar.php", {
                body: { ...dadosAgendamento, telefone: telefoneCompleto }
            });
            isLoading = false;

            if (resposta.sucesso) {
                carregarHorarios();
                mensagemConfirmacao = resposta.mensagem;
                mostrarCaixaDialogo = false;
                if (typeof window !== "undefined" && typeof window.gtag === "function") {
                    window.gtag("event", "conversion", {
                        send_to: GOOGLE_ADS_APPOINTMENT_CONVERSION,
                    });
                }
            } else {
                mensagemConfirmacao2 = "Erro ao agendar horário: " + (resposta.erro || "Erro desconhecido");
                mostrarCaixaDialogo = true;
            }
        }
        mostrarCaixaDialogo = false;
    }

    function fecharCaixaDialogo() { mensagemCaixaDialogo = ""; mostrarCaixaDialogo = false; }

    function abrirForm(horario) {
        horarioSelecionado = horario;
        dadosAgendamento.data = horario.inicio.split(" ")[0];
        dadosAgendamento.hora = horario.inicio.split(" ")[1];
        dadosAgendamento.id = horario.id;
        dadosAgendamento.online = horario.online;
        mostrandoModal = true;
    }

    function fecharModal() {
        mostrandoModal = false;
        dadosAgendamento = { nome: "", ddd: "", telefone: "", email: "", data: "", hora: "", id: "", dataNascimento: "", online: 0 };
        horarioSelecionado = null;
        mensagemConfirmacao = "";
        mensagemConfirmacao2 = "";
        mensagemCaixaDialogo = "";
        horarios = [];
        window.location.reload();
        Fechar();
    }

    function Fechar() { dispatch("close"); showModal = false; }
</script>

<LoadingTela {isLoading} />

{#if showModal}
<div class="overlay">
  <div class="booking-card fade-in">

    <!-- Cabeçalho -->
    <div class="brand-header">
      <div class="brand-avatar">
        <img src="/img/logo2.webp" alt="Alline Menezes Nutricionista" />
      </div>
      <h2>Alline Menezes</h2>
      <p>Nutricionista · Campina Grande</p>
    </div>

    <div class="card-body">

      <!-- ETAPA: LISTA DE HORÁRIOS -->
      {#if !mostrandoModal}

        <!-- Toggle Presencial / Online -->
        {#if ordem === 0}
          <div class="toggle-group">
            <button class="toggle-btn {filtroOnline === 0 ? 'active' : ''}" on:click={() => filtroOnline = 0}>
              🏢 Presencial
            </button>
            <button class="toggle-btn {filtroOnline === 1 ? 'active' : ''}" on:click={() => filtroOnline = 1}>
              💻 Online
            </button>
          </div>
        {:else}
          <div class="toggle-group">
            <button class="toggle-btn {filtroOnline === 1 ? 'active' : ''}" on:click={() => filtroOnline = 1}>
              💻 Online
            </button>
            <button class="toggle-btn {filtroOnline === 0 ? 'active' : ''}" on:click={() => filtroOnline = 0}>
              🏢 Presencial
            </button>
          </div>
        {/if}

        <!-- Lista de horários -->
        <div class="lista-horarios">
          {#if horariosFiltrados.length === 0}
            <div class="empty-state">
              <i class="far fa-calendar-times"></i>
              <p>Nenhum horário {filtroOnline === 1 ? 'online' : 'presencial'} disponível no momento.</p>
            </div>
          {:else}
            {@const grupos = agruparPorData(horariosFiltrados)}
            {#each Object.entries(grupos) as [data, lista]}
              <div class="date-group fade-in">
                <div class="date-header">
                  <span class="date-main">{formatarData(data)}</span>
                  <span class="date-sub">{getDiaDaSemana(data)}</span>
                </div>
                <div class="time-grid">
                  {#each lista as horario}
                    {#if apagavel}
                      <label class="time-slot-check">
                        <input type="checkbox"
                          checked={horariosSelecionados.includes(horario.id)}
                          on:change={() => handleSelecaoHorario(horario.id)} />
                        {horario.inicio.split(" ")[1].substring(0,5)}
                      </label>
                    {:else}
                      <button class="time-slot" on:click={() => abrirForm(horario)}>
                        {horario.inicio.split(" ")[1].substring(0,5)}
                      </button>
                    {/if}
                  {/each}
                </div>
              </div>
            {/each}
          {/if}
        </div>

        {#if apagavel && horariosSelecionados.length > 0}
          <button class="btn-danger w-100 mt-3" on:click={apagarHorarios}>
            🗑 Apagar {horariosSelecionados.length} horário(s) selecionado(s)
          </button>
        {/if}

        {#if !apagavel}
          <div class="whatsapp-hint">
            <p>Não encontrou um horário? Fale pelo
              <a href="https://wa.me/5581996280325?text=Olá! Gostaria de agendar uma consulta." target="_blank" rel="noopener" on:click={() => {
                if (typeof window !== "undefined" && typeof window.gtag === "function") {
                  window.gtag("event", "conversion", {
                    send_to: GOOGLE_ADS_WHATSAPP_CONVERSION,
                  });
                }
              }}>WhatsApp</a>
            </p>
          </div>
        {/if}

      {/if}

      <!-- ETAPA: FORMULÁRIO -->
      {#if mostrandoModal}
        <div class="form-header fade-in">
          <button class="btn-back" on:click={() => { mostrandoModal = false; horarioSelecionado = null; }}>
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
          <h3>Seus Dados</h3>
          <div class="selected-info">
            <i class="far fa-calendar-check"></i>
            <span>{formatarData(dadosAgendamento.data)} às {dadosAgendamento.hora.substring(0,5)}</span>
            <span class="badge-tipo">{filtroOnline === 1 ? '💻 Online' : '🏢 Presencial'}</span>
          </div>
        </div>

        <div class="form-body fade-in">
          <div class="input-group">
            <label>Nome Completo *</label>
            <input type="text" class="input-modern" bind:value={dadosAgendamento.nome} placeholder="Como prefere ser chamado?" />
          </div>

          <label class="block-label">Data de Nascimento *</label>
          <div class="row-inputs mb-3">
            <select class="select-modern" bind:value={diaNascimento}
              on:change={() => dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2,"0")}-${diaNascimento.padStart(2,"0")}`}>
              <option value="">Dia</option>
              {#each Array(31).fill(0).map((_,i)=>i+1) as d}
                <option value={d.toString().padStart(2,"0")}>{d}</option>
              {/each}
            </select>
            <select class="select-modern" bind:value={mesNascimento}
              on:change={() => dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2,"0")}-${diaNascimento.padStart(2,"0")}`}>
              <option value="">Mês</option>
              {#each Array(12).fill(0).map((_,i)=>i+1) as m}
                <option value={m.toString().padStart(2,"0")}>{m}</option>
              {/each}
            </select>
            <select class="select-modern" bind:value={anoNascimento}
              on:change={() => dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento.padStart(2,"0")}-${diaNascimento.padStart(2,"0")}`}>
              <option value="">Ano</option>
              {#each Array(new Date().getFullYear()-1900+1).fill(0).map((_,i)=>new Date().getFullYear()-i) as a}
                <option value={a}>{a}</option>
              {/each}
            </select>
          </div>

          <div class="row-inputs mb-3">
            <div class="input-group ddd-input">
              <label>DDD *</label>
              <input type="tel" class="input-modern" maxlength="2" bind:value={dadosAgendamento.ddd} placeholder="83" />
            </div>
            <div class="input-group telefone-input">
              <label>WhatsApp / Celular *</label>
              <input type="tel" class="input-modern" maxlength="9" bind:value={dadosAgendamento.telefone} placeholder="900000000" />
            </div>
          </div>

          <div class="input-group">
            <label>E-mail (opcional)</label>
            <input type="email" class="input-modern" bind:value={dadosAgendamento.email} placeholder="seu@email.com" />
          </div>

          <button class="btn-primary w-100 mt-4" on:click={confirmarAgendamento}>
            Confirmar Agendamento <i class="fas fa-check"></i>
          </button>
          <button class="btn-outline w-100 mt-2" on:click={fecharModal}>Cancelar</button>
        </div>
      {/if}

      <!-- Propaganda Hora na Mão -->
      <div class="cta-footer">
        <p class="cta-text">Quer um sistema de agendamento assim para o seu consultório? Sem mensalidade no primeiro mês.</p>
        <a href="https://horanamao.com.br" target="_blank" class="cta-link">Conheça o Hora na Mão →</a>
      </div>

    </div>

    <!-- Botão fechar (canto superior direito) -->
    {#if !apagavel}
      <button class="btn-close-card" on:click={Fechar} aria-label="Fechar">✕</button>
    {/if}

  </div>
</div>
{/if}

<CaixaDeDialogo
    tipo="confirmacao" titulo="Confirmação"
    on:close={() => { mensagemCaixaDialogo = ""; }}
    message={mensagemCaixaDialogo}
    button1Label={Constantes.botao_cancelar}
    button3Label={"Confirmar"}
    button3Action={confirmarAcao}
    button2Action={fecharCaixaDialogo}
    button1Action={fecharCaixaDialogo}
/>
<CaixaDeDialogo
    tipo="confirmacao" titulo="Confirmação"
    on:close={() => { mensagemConfirmacao = ""; }}
    message={mensagemConfirmacao}
    button1Label={"Ok"}
    button1Action={fecharModal}
/>
<CaixaDeDialogo
    tipo="confirmacao" titulo="Confirmação"
    on:close={() => { mensagemConfirmacao2 = ""; }}
    message={mensagemConfirmacao2}
    button1Label={"Ok"}
    button1Action={() => { mensagemConfirmacao2 = ""; }}
/>

<style>
  :root {
    --primary: #a1b57d;
    --primary-dark: #8aa864;
    --secondary-light: #f4f8f0;
    --bg-app: #f4f7f5;
    --text-main: #2c3e34;
    --text-muted: #738a7c;
    --border: #e0e6e2;
  }

  .overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 900; padding: 16px;
    backdrop-filter: blur(2px);
  }

  .booking-card {
    background: #fff;
    border-radius: 16px;
    width: 100%; max-width: 500px;
    max-height: 92vh; overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    border-top: 6px solid var(--primary);
    position: relative;
    font-family: 'Montserrat', -apple-system, sans-serif;
  }

  .booking-card::-webkit-scrollbar { width: 6px; }
  .booking-card::-webkit-scrollbar-thumb { background: var(--border); border-radius: 10px; }

  /* Cabeçalho */
  .brand-header {
    background: var(--secondary-light);
    padding: 28px 20px 20px;
    text-align: center;
    border-bottom: 1px solid var(--border);
  }
  .brand-avatar {
    width: 130px; height: 60px;
    margin: 0 auto 12px;
    display: flex; align-items: center; justify-content: center;
  }
  .brand-avatar img { width: 100%; height: 100%; object-fit: contain; }
  .brand-header h2 { margin: 0; font-size: 1.2rem; font-weight: 800; color: var(--primary); }
  .brand-header p  { margin: 4px 0 0; font-size: 0.85rem; color: var(--text-muted); }

  /* Botão fechar */
  .btn-close-card {
    position: absolute; top: 12px; right: 14px;
    background: rgba(0,0,0,0.06); border: none;
    width: 30px; height: 30px; border-radius: 50%;
    font-size: 0.85rem; cursor: pointer; color: var(--text-muted);
    display: flex; align-items: center; justify-content: center;
  }
  .btn-close-card:hover { background: rgba(0,0,0,0.12); }

  .card-body { padding: 24px 22px; }

  /* Toggle */
  .toggle-group {
    display: flex; gap: 8px; margin-bottom: 20px;
  }
  .toggle-btn {
    flex: 1; padding: 10px; border: 1px solid var(--border);
    border-radius: 8px; background: var(--bg-app);
    font-weight: 600; font-size: 0.9rem; cursor: pointer;
    color: var(--text-muted); transition: all 0.2s;
  }
  .toggle-btn.active {
    background: var(--primary); color: #fff; border-color: var(--primary);
  }

  /* Lista de horários */
  .lista-horarios { max-height: 380px; overflow-y: auto; padding-right: 4px; }
  .lista-horarios::-webkit-scrollbar { width: 5px; }
  .lista-horarios::-webkit-scrollbar-thumb { background: var(--border); border-radius: 10px; }

  .date-group { margin-bottom: 22px; }
  .date-header {
    display: flex; align-items: baseline; gap: 8px;
    margin-bottom: 10px; padding-bottom: 5px;
    border-bottom: 1px solid var(--border);
  }
  .date-main { font-weight: 700; color: var(--primary); font-size: 1rem; }
  .date-sub  { font-size: 0.8rem; color: var(--text-muted); text-transform: uppercase; }

  .time-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
    gap: 8px;
  }
  .time-slot {
    background: var(--bg-app); border: 1px solid var(--border);
    color: var(--text-main); padding: 11px 0;
    border-radius: 8px; font-weight: 600; font-size: 0.9rem;
    cursor: pointer; transition: all 0.2s;
  }
  .time-slot:hover {
    background: var(--primary); color: #fff;
    border-color: var(--primary); transform: translateY(-2px);
  }
  .time-slot-check {
    display: flex; align-items: center; justify-content: center; gap: 6px;
    background: var(--bg-app); border: 1px solid var(--border);
    padding: 11px 6px; border-radius: 8px;
    font-weight: 600; font-size: 0.9rem; cursor: pointer;
  }

  .empty-state { text-align: center; padding: 36px 20px; color: var(--text-muted); }
  .empty-state i { font-size: 2.2rem; color: var(--border); display: block; margin-bottom: 10px; }

  /* Formulário */
  .form-header { text-align: center; margin-bottom: 22px; position: relative; padding-top: 32px; }
  .btn-back {
    position: absolute; left: 0; top: 0;
    background: none; border: none; color: var(--text-muted);
    font-weight: 600; font-size: 0.88rem; cursor: pointer;
  }
  .btn-back:hover { color: var(--primary); }
  .form-header h3 { margin: 0 0 12px; font-size: 1.1rem; font-weight: 800; color: var(--primary); }
  .selected-info {
    display: inline-flex; align-items: center; gap: 8px;
    background: var(--secondary-light); padding: 7px 14px;
    border-radius: 20px; font-size: 0.82rem; font-weight: 600; color: var(--primary);
    flex-wrap: wrap; justify-content: center;
  }
  .badge-tipo {
    background: var(--primary); color: #fff;
    padding: 2px 8px; border-radius: 10px; font-size: 0.75rem;
  }

  .input-group { margin-bottom: 14px; display: flex; flex-direction: column; }
  .input-group label, .block-label {
    font-size: 0.82rem; font-weight: 700; color: var(--text-main);
    margin-bottom: 5px; display: block; text-align: left;
  }
  .input-modern, .select-modern {
    width: 100%; padding: 11px 14px;
    border: 1px solid var(--border); border-radius: 8px;
    font-family: inherit; font-size: 0.93rem;
    background: var(--bg-app); transition: border-color 0.2s;
  }
  .input-modern:focus, .select-modern:focus {
    outline: none; border-color: var(--primary); background: #fff;
    box-shadow: 0 0 0 3px rgba(161,181,125,0.15);
  }
  .row-inputs { display: flex; gap: 8px; }
  .ddd-input { flex: 0 0 80px; }
  .telefone-input { flex: 1 1 auto; }
  .mb-3 { margin-bottom: 14px; }
  .mt-3 { margin-top: 14px; }
  .mt-4 { margin-top: 20px; }
  .mt-2 { margin-top: 8px; }
  .w-100 { width: 100%; }

  .btn-primary {
    background: var(--primary); color: #fff; border: none;
    padding: 13px; border-radius: 8px; font-weight: 700;
    font-size: 0.97rem; cursor: pointer; transition: background 0.2s;
  }
  .btn-primary:hover { background: var(--primary-dark); }

  .btn-outline {
    background: transparent; color: var(--primary);
    border: 2px solid var(--primary); padding: 11px;
    border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.2s;
  }
  .btn-outline:hover { background: var(--secondary-light); }

  .btn-danger {
    background: #dc3545; color: #fff; border: none;
    padding: 11px; border-radius: 8px; font-weight: 700; cursor: pointer;
  }
  .btn-danger:hover { background: #bb2d3b; }

  /* WhatsApp hint */
  .whatsapp-hint {
    text-align: center; margin-top: 18px;
    font-size: 0.85rem; color: var(--text-muted);
  }
  .whatsapp-hint a { color: var(--primary); font-weight: 600; }

  /* CTA Hora na Mão */
  .cta-footer {
    text-align: center; padding: 18px 0 4px;
    margin-top: 24px; border-top: 1px solid var(--border);
  }
  .cta-text { font-size: 0.82rem; color: var(--text-muted); margin-bottom: 6px; }
  .cta-link {
    color: var(--primary); text-decoration: none;
    font-weight: 700; font-size: 0.88rem;
  }
  .cta-link:hover { text-decoration: underline; }

  /* Animação */
  .fade-in { animation: fadeIn 0.3s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

  @media (max-width: 480px) {
    .overlay { padding: 0; align-items: flex-end; }
    .booking-card { border-radius: 16px 16px 0 0; max-height: 96vh; max-width: 100%; }
    .row-inputs { flex-direction: column; }
    .ddd-input { flex: 1 1 auto; }
  }
</style>
